/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import type {EmptyCellValueMode} from '../types/Api';

/** Placeholder shown in place of an empty cell value. Empty string renders
 * nothing, keeping the cell visually clean. */
export const EMPTY_CELL_PLACEHOLDER = '';

/** Placeholder shown in place of an empty cell value in DASH mode.
 * En dash (U+2013) — visually longer than a hyphen, the typographic
 * convention for "no value" in tables. */
export const DASH_CELL_PLACEHOLDER = '–';

/** Resolves the emptyCellValueMode setting to the placeholder string renderers display. */
export const EMPTY_CELL_VALUE_BY_MODE: Record<EmptyCellValueMode, string> = {
  NOTHING: EMPTY_CELL_PLACEHOLDER,
  DASH: DASH_CELL_PLACEHOLDER,
};
